/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Box, Flex, Text, Divider } from '@tishman/components';

import { selectRefund, useAppSelector } from '../../../store';
import { formatMoney } from '../../../utils';

const spaceBetween = { justifyContent: 'space-between', mb: 2 };

export function RefundSummary() {
  const refund = useAppSelector(selectRefund);

  if (!refund) return null;

  return (
    <Box>
      <Text sx={{ mt: [0, 4], mb: 3 }} variant="rockCenterPageName">
        Your refund has been submitted
      </Text>
      <Divider />
      <Flex sx={{ ...spaceBetween, mt: 3 }}>
        <Text variant="executiveTitle">Total</Text>
        <Text sx={{ fontWeight: 'medium' }} variant="largeP">
          {formatMoney(refund.totalWithTax)}
        </Text>
      </Flex>
    </Box>
  );
}
